export function useLocale(locale) {
  const messages = {
    en: {
      next: 'Next',
      back_to_exercise: '< Back to exercise',
      lesson: 'Lesson',
      send: 'Submit',
      submit: 'Submit',
      close: 'Close',
      word_bank: 'Word bank',
      my_answer: 'My answer',
      bonus: 'Bonus',
      reflection: 'Pause and think',
      correct: 'Try again',
      cancel: 'Cancel',
      attempts_left: 'Attempts left',
      finish: 'Finish lesson',
      changes_requested: 'Teacher requested changes, retry',
      reset: 'Reset',
      reset_title: 'איפוס תשובות',
      reset_question: 'האם אתה בטוח שברצונך לאפס את השאלה?',
      reset_message: 'איפוס ימחק את כל התשובות שענית ויחזור לנקודת ההתחלה.',
      reset_cancel: 'Cancel',
      reset_confirm: 'איפוס תשובות',
      full_screen: 'Full Screen',
      exit_full_screen: 'Exit Full Screen',
      // AI Feedback Keys
      ai_feedback: 'AI Feedback',
      performance_correct: 'Fully correct',
      performance_incorrect: 'Incorrect',
      performance_partial: 'Partially correct',
      suggestions: 'Suggestions for improvement',
      explanation: 'Explanation',
      i_have_comment: 'I have a comment',
      feedback_comment_title: 'Feedback Comment',
      ai_feedback_explanation:
        'This feedback was provided by artificial intelligence. If you have an issue with the content you received, we would love to hear from you – this will help us improve the system. The comment will not be shown to the teacher and will not affect your grade.',
      feedback_issue_question:
        'What was inaccurate or problematic in the feedback?',
      comment_placeholder: 'Write your comment here...',
      submit_comment: 'Submit Comment',
      ai_processing: 'AI is analyzing your answer...',
      ai_feedback_settings: 'AI Feedback Settings',
      enable_ai_feedback: 'Enable AI Feedback',
      ai_feedback_description:
        'Provide personalized AI-generated feedback for student submissions',
      supported_components: 'Supported Components',
      component_freetext: 'Free Text (Long answers)',
      component_textarea: 'Text Area (Short answers)',
      component_highlight: 'Text Highlighting',
      fallback_feedback: 'Static Feedback (Fallback)',
      feedback_placeholder: 'Enter feedback text for this score range...',
      // AI Performance Labels
      ai_label_correct: 'Correct Performance',
      ai_label_incorrect: 'Incorrect Performance',
      ai_label_partial: 'Partially Correct',
      ai_label_failed: 'Failed Performance',
    },
    he: {
      next: 'הבא',
      back_to_exercise: '< חזרה לתרגיל',
      lesson: 'שיעור',
      send: 'שלח',
      submit: 'הגשה',
      close: 'סגור',
      finish: 'סיום השיעור',
      word_bank: 'בנק תשובות',
      my_answer: 'התשובה שלי',
      bonus: 'בונוס',
      reflection: 'עוצרים חושבים',
      correct: 'תיקון',
      cancel: 'ביטול תיקון',
      attempts_left: 'אפשרויות תיקון נשארו',
      changes_requested: 'המורה ביקש שינויים, נסה שוב',
      reset: 'איפוס',
      reset_title: 'איפוס תשובות',
      reset_question: 'האם אתה בטוח שברצונך לאפס את השאלה?',
      reset_message: 'איפוס ימחק את כל התשובות שענית ויחזור לנקודת ההתחלה.',
      reset_cancel: 'ביטול',
      reset_confirm: 'איפוס תשובות',
      full_screen: 'מסך מלא',
      exit_full_screen: 'יציאה ממסך מלא',
      // AI Feedback Keys
      ai_feedback: 'משוב AI',
      performance_correct: 'נכון לחלוטין',
      performance_incorrect: 'לא נכון',
      performance_partial: 'נכון חלקית',
      suggestions: 'הצעות לשיפור',
      explanation: 'הסבר',
      i_have_comment: 'שליחת הערה',
      feedback_comment_title: 'המשוב AI היה לא מדויק? ספרו לנו!',
      ai_feedback_explanation:
        'המשוב ניתן על-ידי בינה מלאכותית. אם יש בעיה בתוכן שקיבלת, נשמח לשמוע – זה יעזור לנו לשפר את המערכת. ההערה לא תוצג למורה ולא תשפיע על הציון',
      feedback_issue_question: 'מה היה לא מדויק או בעייתי במשוב?',
      comment_placeholder: 'כתבו כאן את ההערה שלכם...',
      submit_comment: 'שליחת הערה',
      ai_processing: 'AI מנתח את התשובה שלך...',
      ai_feedback_settings: 'הגדרות משוב AI',
      enable_ai_feedback: 'הפעל משוב AI',
      ai_feedback_description:
        'ספק משוב מותאם אישית שנוצר על ידי AI עבור הגשות תלמידים',
      supported_components: 'רכיבים נתמכים',
      component_freetext: 'טקסט חופשי (תשובות ארוכות)',
      component_textarea: 'אזור טקסט (תשובות קצרות)',
      component_highlight: 'הדגשת טקסט',
      fallback_feedback: 'משוב סטטי (גיבוי)',
      feedback_placeholder: 'הזן טקסט משוב עבור טווח ציון זה...',
      // AI Performance Labels
      ai_label_correct: 'ביצוע תקין',
      ai_label_incorrect: 'ביצוע לא תקין',
      ai_label_partial: 'ביצוע חלקי',
      ai_label_failed: 'ביצוע לא תקין',
    },
  };

  const getLocalizedText = key => {
    const lc = locale.value || 'he';
    return messages[lc][key] || '';
  };

  return {
    getLocalizedText,
  };
}
